import './CoverRequestCard.scss';

import React, { PureComponent } from 'react';
import * as routes from 'api';
import { Map } from 'immutable';
import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card';
import PropTypes from 'prop-types';
import { composites, dimensions, typography } from 'theme/constants';

import Box from 'components/Box';
import Button from 'components/clickables/Button';
import DateTile from 'components/DateTile';

import cxHelpers from 'util/className';
import { df, duration, momentInZone } from 'util/dateTime';
import { toI18n } from 'util/i18n';

const CARD_ACTIONS_STYLE = { padding: 0 };

@cxHelpers('CoverRequestCard')
export default class CoverRequestCard extends PureComponent {
  static propTypes = {
    coverRequest: PropTypes.instanceOf(Map).isRequired,
    senderName: PropTypes.string.isRequired,
  };

  render() {
    const { senderName, coverRequest } = this.props;

    const firstName = senderName.split(' ')[0].toUpperCase();
    const shift = coverRequest.get('shift');
    const startAt = momentInZone(shift.get('start_at'), 'full', {
      fromUTC: true,
    });
    const endAt = momentInZone(shift.get('end_at'), 'full', { fromUTC: true });

    const parsableDate = startAt.format(df('parsable_date'));
    const diff = duration(endAt.diff(startAt)).asHours();
    const startTime = startAt.format(df('msg_time'));
    const endTime = endAt.format(df('msg_time'));

    const locationName = shift.get('location_name');
    const roleName = shift.get('role_name');

    const headerStyle = {
      borderBottom: composites.defaultBorder,
      padding: dimensions.xs,
    };

    const headerTextStyle = {
      paddingRight: 30,
      verticalAlign: 'middle',
    };

    const headerTitleStyle = {
      fontWeight: typography.fw700,
      fontSize: typography.fs12,
      lineHeight: typography.fs12,
    };

    const textStyle = {
      borderBottom: composites.defaultBorder,
      padding: dimensions.xs,
    };

    return (
      <Card className={this.cx()} initiallyExpanded>
        <CardHeader
          title={toI18n('messenger.messages.cover_request.title', {
            props: { firstName },
          })}
          actAsExpander
          showExpandableButton
          style={headerStyle}
          textStyle={headerTextStyle}
          titleStyle={headerTitleStyle}
        />

        <CardText expandable style={textStyle}>
          <Box vcenter>
            <DateTile parsableDate={parsableDate} inZone />
            <div className="mlxs">
              <div className="mbxxxs">
                <strong>
                  {startTime} - {endTime}
                </strong>
              </div>
              <div className="mbxxxs">
                <strong>{diff} Hours</strong>
              </div>
              <span>
                {roleName && `${roleName} | `}
                {locationName}
              </span>
            </div>
          </Box>
        </CardText>

        <CardActions style={CARD_ACTIONS_STYLE}>
          <Button href={routes.profileRoute(parsableDate)} theme="link-purple">
            {toI18n('messenger.messages.cover_request.link')}
          </Button>
        </CardActions>
      </Card>
    );
  }
}
